(ns ycweb.app.admin.buying.rangereview.printreview
  (:require
   [rum.core :as rum]
   [ycweb.app.admin.buying.rangereview.common :as rangecmn]
   [ycweb.app.website.cards :as awc]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.grid :as grid]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.components.buttons :as buttons]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))

;; Review Products
(rum/defc review-line-item < rum/reactive [app-atom item]
  [:td.grid-column.u-print-td
   (awc/trend-card app-atom item nil nil)])

(rum/defc review-line < rum/reactive [app-atom group-items]
  [:tr.u-display-contents.u-print-tr
   (list
     (concat
       (map (partial review-line-item app-atom) group-items)
       (repeat (- 4 (count group-items)) [:td.grid-column.u-print-td ""])))])

(rum/defc rangereview-review-products < rum/reactive cmn/cursors [app-atom]
  (let [action-atom (cmn/action-cursor app-atom)
        {:category/keys [status] :as category} (cmn/curact action-atom [:category])
        range-review (cmn/curact action-atom [:range-review])
        variations
        (->>
          (cmn/curact action-atom [:variations])
          (vals)
          (sort-by (juxt (comp :variation/suggested? :item-line/variation) (comp :variation/price :item-line/variation)))
          (partition-all 4))]
    [:div.admin-react-wrapper__content
     (rangecmn/rangereview-header app-atom :print nil)
     [:table.u-display-block.u-margin-bottom-40.u-print-table.u-print-range-review
      [:tbody.u-print-tbody
       {:class (u/bem :grid [:xl-1-5 :l-1-4 :m-1-3 :t-1-2])}
       (map (partial review-line app-atom) variations)]]
     [:div.admin-action-bar.u-do-not-print
      [:div
       {:class
        (u/bem
          :flex-grid-group
          [:row-reversed :align-between :valign-middle :flush])}
       [:div.u-min-width-240
        {:class (u/bem :flex-grid-block [:fluid :flush])}
        [:div.flex-grid-content
         [:div
          {:class
           (u/bem :flex-grid-group [:row-reversed :valign-middle :flush])}
          [:div.u-min-width-240
           {:class (u/bem :flex-grid-block [:fluid])}
           [:div.flex-grid-content
            (buttons/button-web
              (if (and status (= status :range-review-constraint.status/complete))
                "Mark as Draft"
                "Mark as Complete")
              {:style :primary
               :size :default
               :on-click
               #(grid/dispatch-action app-atom :admin.rangereview/update-print-category-status
                  {:category-uuid (:ent/uuid category)
                   :review-uuid (:ent/uuid range-review)
                   :new-status (if (and status (= status :range-review-constraint.status/complete)) :range-review-constraint.status/draft :range-review-constraint.status/complete)})
               :full true
               :icon :success})]]
          [:div.u-min-width-240
           {:class (u/bem :flex-grid-block [:fluid])}
           [:div.flex-grid-content
            (buttons/button-web "Print plan"
              {:style :secondary
               :size :default
               :on-click (fn [] #?(:cljs (.print js/window)))
               :full true
               :icon :document-download})]]
          [:div.u-min-width-240
           {:class (u/bem :flex-grid-block [:fluid])}
           [:div.flex-grid-content
            (buttons/button-web "Digital review plan"
              (merge
                (urlstate/href-props app-atom "rangereview" "digital" {:review-uuid (:ent/uuid range-review) :category-uuid (:ent/uuid category)})
                {:style :secondary
                 :size :default
                 :full true}))]]]]]
       [:div.u-min-width-240
        {:class (u/bem :flex-grid-block [:fluid :flush])}
        [:div.flex-grid-content
         (buttons/button-web "Back"
          (merge
            (urlstate/href-props app-atom "rangereview" "select-products" {:review-uuid (:ent/uuid range-review) :category-uuid (:ent/uuid category)})
            {:style :secondary
             :size :default
             :full true
             :icon :arrow-left}))]]]]
     (toaster/loading-overlay app-atom :admin.rangereview/print-review)]))

(defmethod grid/action :admin.rangereview/update-print-category-status [app-atom config _]
  (grid/open-modal app-atom :rangereview/complete-cat)
  (let [category-atom (rum/cursor-in (cmn/action-cursor app-atom) [:category])]
    (swap! category-atom assoc
      :category/status (:new-status config)))
  (comms/send :admin.rangereview/update-category-status config)
  (grid/open-modal app-atom :rangereview/complete-cat))

(defmethod flow/render-screen :admin.rangereview/print [app-atom _]
  (rangereview-review-products app-atom))

(defmethod t/transition-open :admin.rangereview/print [app-atom _ params]
  (toaster/open-overlay app-atom :admin.rangereview/print-review)
  (swap! (cmn/action-cursor app-atom) assoc
    :review-uuid (:review-uuid params)
    :category-uuid (:category-uuid params)
    :variations nil)
  (comms/send :admin.rangereview/print-products
    (assoc params
      :view-products :all
      :with-history? true
      :included-only? true)))

(defmethod comms/receive :admin.rangereview/print-products [app-atom e]
  (swap! (cmn/action-cursor app-atom) assoc
    :category (:category e)
    :growth (:growth e)
    :range-review (:range-review e)
    :category-stats (:category-stats e)
    :category-stats-prev (:category-stats-prev e)
    :variations (:variations e))
  (toaster/close-overlay app-atom :admin.rangereview/print-review))

(rum/defc product-added-modal-body < rum/reactive [app-atom]
  [:p.yc-paragraph
   "Category status updated"])

(rum/defc product-added-modal-footer < rum/reactive [app-atom]
  (let [action-atom (cmn/action-cursor app-atom)
        {:category/keys [status] :as category} (cmn/curact action-atom [:category])
        range-review (cmn/curact action-atom [:range-review])]
    [:div
     (grid/button-row
       {:left-text "Stay here"
        :left-fn #(grid/close-modal app-atom)
        :left-no-icon true
        :right-text "Back to categories"
        :right-fn #(urlstate/redirect app-atom "rangereview" "category" {:review-uuid (:ent/uuid range-review) :category-uuid (:category/prev-level category)})
        :right-no-icon true})]))

(defmethod grid/action :admin.rangereview/close-complete-cat [app-atom config _]
  (grid/close-modal app-atom))

(defmethod grid/modal-config :rangereview/complete-cat [_ _ _]
  {:body product-added-modal-body
   :footer product-added-modal-footer
   :cancel-key :admin.rangereview/close-complete-cat
   :modal-type :variable
   :max-width 480})

